<template>
    <div class="page" :style="payDisabled?styleObject:{}">
        <div class="xf-btn-list">
            <div class="xf-btn" @click="close()" style="color: #fff">返回</div>
        </div>
        <div class="list">
            <ul class="list-container">
                <div v-if="list.length==0" style="text-align: center;padding: 5vw 0;background-color: #fff;font-size: 4.2vw ">暂无待缴清单</div>
                <li v-else v-for="item in list" class="item">
                    <div class="item-header"><span
                            class="title">{{item.start_time.time1}}-{{item.end_time.time1}}期</span></div>
                    <div class="item-content" style="">

                        <div class="info-item">
                            <span class="title">上期抄表时间</span>
                            <span>{{item.start_time.time2}}</span>
                        </div>

                        <div class="info-item">
                            <span class="title">上期吨数</span>
                            <span>{{item.last_count}}吨</span>
                        </div>
                        <div class="info-item">
                            <span class="title">本期抄表时间</span>
                            <span>{{item.end_time.time2}}</span>
                        </div>

                        <div class="info-item">
                            <span class="title">本期吨数</span>
                            <span>{{item.now_count}}吨</span>
                        </div>

                        <div class="info-item">
                            <span class="title">实际用水量</span>
                            <span>{{item.count}}吨</span>
                        </div>

                        <div class="info-tip">
                            <span>费用明细</span>
                        </div>
                        <div class="info-item">
                            <span>单价</span>
                            <span>{{item.price}}元</span>
                        </div>
                        <div class="info-item">
                            <span>应缴</span>
                            <span>{{item.total}}元</span>
                        </div>
                        <div class="info-item">
                            <span>表底</span>
                            <span>{{ item.penalty==0?'无':item.penalty+'元' }}</span>
                        </div>
                        <div class="info-item">
                            <span>其他费用</span>
                            <span>{{item.charge_items?'':'无'}}</span>
                        </div>
                        <div class="info-item" v-if="item.charge_items_price>0"
                             v-for="cItem in JSON.parse(item.charge_items)">
                            <span>{{cItem.value}}</span>
                            <span>{{cItem.price}}元</span>
                        </div>

                        <div class="info-item total">
                            <span>总计</span>
                            <span>{{item.total_price}}元</span>
                        </div>

                        <div class="btn-content">
                            <span @click="pay(item.id)" class="btn">支付</span>
                        </div>

                    </div>

                </li>


            </ul>

        </div>

        <div class="pay_list" v-if="payDisabled" @click="payDisabled=false">

            <div class="pay-block">
                <div style="color: #666;font-size: 5vw">请选择支付方式</div>
                <div @click="go('wx')" style="height: 10vw"><img style="height: 100%" src="../assets/wxf.png"/></div>
<!--                <div @click="go('ali')" style="height: 8vw"><img style="height: 100%" src="../assets/zff.png"/></div>-->
            </div>

        </div>

    </div>
</template>

<script>
    import {getFeeRecord} from "../api/api";

    export default {
        name: "FeeList"
        , data() {
            return {
                info: '',
                list: []
                , payDisabled: false
                , styleObject: {
                    overflow: 'hidden'
                }
                , payID: ''
            }
        }, methods: {
            close() {
                this.$router.push({
                    path: '/'
                });
            },
            _getFeeRecord() {
                let query = {};
                if (sessionStorage.getItem('select')) {
                    query.id = JSON.parse(sessionStorage.getItem('select')).id
                }

                getFeeRecord(query).then(res => {
                    this.list = res.data;
                });

            }, pay(id) {
                this.payDisabled = true;

                this.payID = id;
                // this.$router.push({
                //     path:'/pay'
                //     ,query:{id:id}
                // });

            }, go(cate) {

                this.$router.push({
                    path: '/pay'
                    , query: {id: this.payID, cate: cate}
                });

            }

        }, created() {
            this._getFeeRecord();
        }
    }
</script>

<style scoped>

    .page {

    }

    .list {
        overflow: auto;
        margin-top: 4vw;
        border-radius: 5px;
    }

    .list .item {
        background-color: #fff;
        margin-bottom: 5vw;
        border-radius: 5px;
    }

    .list-container {
    }

    .list-container .item {
        border-bottom: 1px solid #e5e5e5;
    }

    .list-container .item:last-child {
        border-bottom: none;
    }

    .list-container .item-header {
        font-size: 4.5vw;
        padding: 4vw 3vw;
        display: flex;
        flex-direction: row;
    }

    .item-header .icon {
        flex: 1;
        text-align: right;

    }

    .list-container .item-content {
        padding: 2vw 3vw;
        background-color: #e8e8e8;
        font-size: 4vw;
    }

    .item-content {
        /*display: none;*/

    }

    .item-content.active {
        display: block;
    }

    .item-content .info-item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 1vw 0;
    }

    .item-content .info-tip {
        padding-top: 3.5vw;
        line-height: 1.8;
        border-bottom: 1px solid #b4b4b4;
        margin-bottom: 2vw;
        /*padding-bottom: 2vw;*/
        color: #363334;
        /*background-color: #fff;*/
    }

    .info-item.total {
        color: #1cbac6;
    }

    .info-item .title {
        color: #333;
    }

    .item-content .btn-content {
        padding: 4vw 0;
        text-align: center;
    }

    .item-content .btn {
        color: #fff;
        background-color: #3e94ff;
        padding: 2vw 20vw;
        border-radius: 5px;
    }

    .pay_list {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.37);
    }

    .pay-block {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 50vw;
        right: 0;
        margin-left: -30vw;
        width: 60vw;
        height: 50vw;
        background-color: #fff;
        margin-top: 50vw;
        display: flex;
        flex-direction: column;
        border-radius: 5px;
        padding: 2vw;

    }

    .pay-block div {
        padding: 2vw 0 2vw 0;
        border-bottom: 1px solid #e5e5e5;
        text-align: center;
    }

    .xf-btn-list .xf-btn {
        position: fixed;
        height: 15vw;
        width: 15vw;
        bottom: 3vw;
        right: 3vw;
        border-radius: 100%;
        background-color: #1886ed;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        box-shadow: 2Px 2Px 10Px 0 rgba(0, 0, 0, 0.22);
    }

</style>
